import React from 'react';
import { Navigate, Outlet, Link } from 'react-router-dom';
import { useOrganizerAuth } from '../../context/OrganizerAuthContext';
import { AdminShell, AdminTopBar, AdminBrand, AdminNav, AdminMain } from '../../styles/adminStyles';
import LanguageSwitcher from '../../components/LanguageSwitcher';
import { usePortalT } from '../../i18n/usePortalT';

export default function OrganizerProtectedRoute() {
  const { user, loading, logout } = useOrganizerAuth();
  const { t } = usePortalT();

  if (loading) {
    return (
      <AdminShell>
        <AdminMain><p>{t('common.loading')}</p></AdminMain>
      </AdminShell>
    );
  }

  if (!user) {
    return <Navigate to="/organizer/login" replace />;
  }

  return (
    <AdminShell>
      <AdminTopBar>
        <AdminBrand>{t('orgNav.brand')}</AdminBrand>
        <AdminNav>
          <Link to="/organizer">{t('orgNav.myActivities')}</Link>
          <Link to="/organizer/new">{t('orgNav.create')}</Link>
          <Link to="/organizer/route-rewards">{t('orgNav.routeRewards')}</Link>
          <Link to="/organizer/vouchers">{t('orgNav.vouchers')}</Link>
          <span>{user.displayName || user.username}</span>
          <LanguageSwitcher compact />
          <button type="button" onClick={logout} style={{ background: 'none', border: 'none', cursor: 'pointer', fontWeight: 700 }}>
            {t('common.logout')}
          </button>
        </AdminNav>
      </AdminTopBar>
      <AdminMain>
        <Outlet />
      </AdminMain>
    </AdminShell>
  );
}
